<template>
  <li class="box d-flex justify-content-between">
    <section class="d-flex grow-1 align-items-center">
      <a v-if="!editing" :href="url" :target="id">{{ title }}</a>
      <form @submit.prevent="update(id)" class="mr-4 grow-1">
        <input
          v-if="editing"
          v-select
          class="input file-name-input grow-1"
          v-model="name"/>
      </form>
    </section>
    <section class="d-flex flex-column" >
      <input
        v-if="editing"
        @click="editing = false"
        class='button is-small'
        type='button'
        value='cancel'
        name='cancel'/>
      <button
        v-if="editing"
        @click="update(id, name)"
        class='button is-small is-success'
        :class="updating && 'is-loading'"
        type='button'
        value='save'>
        save
      </button>
      <input
        v-if="editing"
        @click="showDelete = !showDelete"
        class='button is-small is-danger'
        type='button'
        value='delete'
        name='delete'/>
      <input
        v-if="!editing"
        @click="editing = true"
        class='button is-small'
        type='button'
        value='edit'
        name='edit'/>
      <input
        @click="showAdd = !showAdd"
        class='button is-small is-info'
        type='button'
        value='make a copy'
        name='make a copy'/>
    </section>

    <Confirm
      @cancel="showDelete = false"
      @confirm="remove(id)"
      title="Deleting File"
      message="Are you sure you want to delete the file?"
      :show="showDelete"
      :loading="deleting"
    />

    <AddtoVideoModal
      v-if="showAdd"
      :resource="id"
      @close="showAdd = false"
    />

  </li>
</template>

<script>
import { select } from '../directives.js'
import Confirm from './Confirm.vue'
import AddtoVideoModal from './AddtoVideoModal.vue'

import store from '../store.js'

export default {
  name: 'FileResource',
  components: {
    Confirm,
    AddtoVideoModal,
  },
  directives: {
    select,
  },
  watch: {
    editing (val) {
      // we want to set the initial value of the text input, but we do not want
      // it to possibly be overwritten while editing by the user
      if (val) {
        this.name = this.title
      }
    },
  },
  props: {
    id: {
      type: Number,
      required: true,
    },
    url: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
  },
  data () {
    return {
      editing: false,
      deleting: false,
      showDelete: false,
      showAdd: false,
      updating: false,
      name: '',
    }
  },
  methods: {
    remove (id) {
      this.deleting = true
      store.dispatch('deleteResourceByID', id)
        .then(() => {
          this.deleting = false
        })
    },
    update (fileID, title) {
      this.updating = true
      store.dispatch('updateFile', { fileID, title })
        .then(() => {
          this.updating = false
          this.editing = false
        })
    },
  },
}
</script>

<style lang="scss" scoped>
.button:not(:last-child) {
  margin-bottom: 0.25rem;
}
</style>



// WEBPACK FOOTER //
// FileResource.vue?5f8249e4